import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21.04 3h-18v18h18V3zm-6 14h-2v-4h-4V7h2v4h2V7h2v10z"
}), 'Looks4Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Looks4Sharp.js
// module id = 4715
// module chunks = 2